import { z } from 'zod';

export const OutdoorBarArticleNonIncludedServiceModelSchema = z.object({
    name: z.string(),
});

export type OutdoorBarArticleNonIncludedServiceModel
    = z.infer<typeof OutdoorBarArticleNonIncludedServiceModelSchema>;
